var mzg;
if (!mzg) {
    mzg = {};
}

$.extend(mzg,
    /**
     * @lends mzg
     */
    {
        /**
         * @namespace
         * @description sidenav will be transformed to slider on mobile 
         */
        subnav: {
            /**
             * @type {function}
             * @description initialize subnav
             */
            obj: $('.list-sidenav:first'),
            slider: null,
            sliderConfig: {
                slidesPerView: 'auto',
                calculateHeight: true,
                grabCursor: true
            },
            sliderBreakpoint: window.matchMedia( "(max-width: 992px)" ),
            mobileSubnavWidth: 0,
            init: function () { 
                     
                mzg.subnav.checkIfSwiperNeeded();
                mzg.subnav.subnavScrolling();
                mzg.subnav.subnavClick();
                
            },
            checkIfSwiperNeeded: function () {
                if(mzg.subnav.sliderBreakpoint.matches){
                    //transform sidenav to slider on mobile
                    //prepare html for swiper
                    mzg.subnav.obj
                        .addClass('swiper-container')
                        .wrapInner('<div class="swiper-wrapper" />')
                        .find('.swiper-wrapper > .list-group-item')
                        .wrap('<div class="swiper-slide" />');
                    
                    mzg.subnav.slider = new Swiper(mzg.subnav.obj, mzg.subnav.sliderConfig);
                    
                } else {
                    if(mzg.subnav.slider != null){
                        mzg.subnav.slider.destroy(true, true);
                    }
                }
            },
            subnavScrolling: function () {
                var $window = $(window),
                    $header = $('.header'),
                    $top = $header.height(),
                    $subnav_fixed = false,
                    $subnav_height = $('.stripe--subnav').height(),
                    $stripe_subnav = $('.stripe--subnav'),
                    $tolerance = 50;

                if($('.stripe--subnav, .list-sidenav').length){
                    var offset = $stripe_subnav.offset().top - $top - $tolerance,
                        $subnav_offsetTopInitial = $stripe_subnav.offset().top,
                        scrollPos = 0;
                    
                    // adding scroll event
                    window.addEventListener('scroll', function(){
                        // detects new state and compares it with the new one
                        var top = (document.body.getBoundingClientRect()).top;
                        if ( top > scrollPos){
                            //console.log("scroll up", (document.body.getBoundingClientRect()).top, " offset:", offset);
                            if(top < (offset * -1)){
                                //console.log('UNFIX UNFIX UNFIX');
                            }

                        } else {
                            //console.log("scroll DOWN DOWN DOWN", (document.body.getBoundingClientRect()).top, " offset:", offset);
                            if(top < (offset * -1)){
                                if(!$subnav_fixed){
                                    $stripe_subnav.addClass("stripe--subnavFixed").css('top',$top);
                                    $stripe_subnav.next('.stripe').css('paddingTop', $subnav_height);
                                    mzg.subnav.obj
                                                .css("width", mzg.subnav.obj.width())
                                                .addClass("list-sidenav--fixed");
                                    if($('.stripe--subnav').children().length > 0) {
                                    } else {
                                        mzg.subnav.obj.css('top',$top);
                                    }
                                }
                                $subnav_fixed = true;
                            }
                        }                        
                        // saves the new position for iteration.
                        scrollPos = (document.body.getBoundingClientRect()).top;
                    });

                    $(window).on('DOMMouseScroll mousewheel', function (event) {
                        //console.log('scrollTop: ',$window.scrollTop(), ' top: ', offset);
                        if(event.originalEvent.detail > 0 || event.originalEvent.wheelDelta < 0) { //alternative options for wheelData: wheelDeltaX & wheelDeltaY
                            if($window.scrollTop() > offset){
                                if(!$subnav_fixed){
                                    $stripe_subnav.addClass("stripe--subnavFixed").css('top',$top);
                                    $stripe_subnav.next('.stripe').css('paddingTop', $subnav_height);
                                    mzg.subnav.obj.addClass("list-sidenav--fixed");
                                }
                                $subnav_fixed = true;
                            }
                        } else {
                            if($window.scrollTop() < $subnav_offsetTopInitial){
                                if($subnav_fixed){
                                    $stripe_subnav.removeClass("stripe--subnavFixed").css('top','');
                                    $stripe_subnav.next('.stripe').css('paddingTop','');
                                    mzg.subnav.obj.removeClass("list-sidenav--fixed");
                                    mzg.subnav.obj.css('top','');
                                }
                                $subnav_fixed = false;
                            }
                        }
                    });  
                }
            },
            checkScrollPosition: function(){
                
            },
            subnavClick: function () {
                $('.list-group-item-action').unbind().on("click", function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    $('.list-sidenav .list-group-item-action.active').removeClass('active');
                    var t = $(this);
                        i = t.parent().index();
                    
                        t.addClass('active');
                        if(mzg.subnav.slider){
                            mzg.subnav.slider.slideTo(i);
                        }

                    $.scrollTo(t.attr('href'), 800, {
                        offset: function () {
                            if($('.stripe--subnav').hasClass('stripe--subnavFixed')) {
                                return {
                                    top: -250
                                };
                            } else {
                                return {
                                    top: -350
                                };
                            }
                        }
                    });
                    
                });
            }
        }
    }
);

$(mzg.subnav.init);
